import type { Operator } from "./index.js"

export const contains: Operator = {
  key: "contains",
  label: "contains",
  icon: "font",
  value: "scalar",
  fn: (a, b) =>
    String(a ?? "")
      .toLowerCase()
      .includes(String(b ?? "").toLowerCase()),
}

export const notContains: Operator = {
  key: "notContains",
  label: "does not contain",
  icon: "font",
  value: "scalar",
  // Null-excluding, matching `LOWER(col) NOT LIKE ...` (NULL in → NULL out →
  // row dropped). See the note on notEquals in equality.ts.
  fn: (a, b) =>
    a != null &&
    !String(a)
      .toLowerCase()
      .includes(String(b ?? "").toLowerCase()),
}

export const startsWith: Operator = {
  key: "startsWith",
  label: "starts with",
  icon: "arrow-right",
  value: "scalar",
  fn: (a, b) =>
    String(a ?? "")
      .toLowerCase()
      .startsWith(String(b ?? "").toLowerCase()),
}

export const endsWith: Operator = {
  key: "endsWith",
  label: "ends with",
  icon: "arrow-left",
  value: "scalar",
  fn: (a, b) =>
    String(a ?? "")
      .toLowerCase()
      .endsWith(String(b ?? "").toLowerCase()),
}
